import Toolbar from './Toolbar';
function noop() { }
;
export function createToolbar() {
    function editorStateChange() {
        // console.log('>> editorStateChange', editorState);
    }
    const callbacks = {
        onChange: editorStateChange,
        onUpArrow: noop,
        onDownArrow: noop,
        getEditorState: noop,
        setEditorState: noop,
        handleReturn: noop,
    };
    return {
        name: 'toolbar',
        decorators: [],
        callbacks,
        onChange(editorState) {
            return callbacks.onChange ? callbacks.onChange() : editorState;
        },
        component: Toolbar,
    };
}



// WEBPACK FOOTER //
// ./ext/editor-core/src/Toolbar/index.tsx